import { configureStore } from '@reduxjs/toolkit'
import userReducer from './features/user/userSlice'
import templateReducer from './features/template/templateSlice'
import experimentReducer from './features/experiment/experimentSlice'
import testStepReducer from './features/testStep/testStepSlice'
import variableReducer from './features/variable/variableSlice'
import machineReducer from './features/machine/machineSlice'
import modeDataReducer from './features/modedata/modeDataSlice'

const initialState = {
  sidebarShow: true,
  asideShow: false,
  sidebarUnfoldable: null,
  theme: 'default',
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest }
    default:
      return state
  }
}

const store = configureStore({
  reducer: {
    ui: changeState,
    user: userReducer,
    templates: templateReducer,
    experiments: experimentReducer,
    testSteps: testStepReducer,
    variables: variableReducer,
    machines: machineReducer,
    modesData: modeDataReducer,
  },
  /*middleware: (getDefaultMiddleware) => [
    ...getDefaultMiddleware().concat(createLogger())
  ]*/
})

export default store
